import React from 'react';
import { Stack } from '@mui/material';
import { CustomerInfoCards } from './CustomerInfoCards';
import { CompanyInformationCard } from './CompanyInformationCard';
import { ActiveOpportunitiesCard } from './ActiveOpportunitiesCard';
import { useGeneralTabDataFetch } from 'modules/customers/hooks/useGeneralTabDataFetch';
import { useParams } from 'react-router-dom';
import { GeneralTabFallback } from './GeneralTabFallback';
import { ProposalsCard } from './ProposalsCard';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

export const CustomerDetailsGeneralTab = () => {
  const { id: customerAccountId } = useParams<{ id: string }>();
  const { isLoading, customerDetails, customerContacts, customerOpportunities, customerProposals } =
    useGeneralTabDataFetch(customerAccountId);

  if (isLoading) {
    return <GeneralTabFallback />;
  }

  return (
    <Stack gap={1}>
      <RenderWithCondition condition={customerDetails}>
        <CustomerInfoCards customerDetails={customerDetails} />
        <CompanyInformationCard customerDetails={customerDetails} customerContacts={customerContacts} />
        <ActiveOpportunitiesCard customerOpportunities={customerOpportunities} />
        <ProposalsCard customerProposals={customerProposals} />
      </RenderWithCondition>
    </Stack>
  );
};
